<template>
  <section>
    <div class="cookies_header">
      DJULI - PROVIDED BY ZIMMER AND PEACOCK AS - Privacy Policy
    </div>
    <div class="cookies_subsection">
      Zimmer &nbsp; Peacock AS (org. no. 917 749 329) ("ZP") cares about individuals’
      privacy and is committed to process personal data in compliance with the
      locally applicable laws and regulations. This privacy policy provides you
      with the information about ZP's processing of personal data, including which
      personal data we collect, why we process your personal data and your rights
      connected to the processing of the personal data.
    </div>

    <div class="cookies_subsection_header">
      For the purpose of this privacy policy, ZP is the data controller.
    </div>
    <br>
    <div class="cookies_subsection_header">
      If you have any questions regarding our processing of personal data or about
      this privacy policy, you may contact ZP by filling the form in this link: <span @click="contactSupport">Contact Support</span>
    </div>

    <section>
      <div class="question">
        PERSONAL DATA, PURPOSE AND LEGAL BASIS FOR PROCESSING
      </div>
      <div class="answer">
        ZP process among others personal data relating to contact persons at its
        customers, service providers and business partners, potential candidates
        and others who contact ZP or visits our webpage. The personal data may be
        provided by the data subject itself, from publicly accessible sources or
        third parties such as service providers, partners etc.
      </div>
      <div class="subanswer">
        We may process your personal data in connection with the following
        processing activities
      </div>
      <div class="type">
        Contractual relationship
      </div>
      <div class="answer">
        In a contractual relationship between ZP and individuals, personal data
        may be necessary to the execution or the performance of the contract (GDPR
        Article 6 (1) (b)), such as contact information and other personal data
        necessary to fulfill the contract.
      </div>

      <div class="type">
        Contract management and business relationship
      </div>
      <div class="answer">
        In connection with the administration and management of contracts with
        ZP's customers, business partners etc. and for business and partner
        relationship purposes, ZP may process personal data such as contact
        information of contact persons at such customers, business partners, in
        addition to personal data contained in contracts, ongoing commercial
        correspondence, invoices, minutes of meeting etc. The legal basis is ZP's
        legitimate interest in entering into business relationships, fulfil
        contracts and administrate such relationship (GDPR Article 6 (1) (f)).
      </div>
      <div class="type">
        Respond to inquiries:
      </div>
      <div class="answer">
        ZP may process personal data in order to follow-up inquiries from
        potential candidates, website users, and others who contact ZP. ZP may
        process personal data such as contact information and other personal data
        provided in connection with the inquiry. The legal basis for such
        processing is ZP's legitimate interest in providing support to answer and
        manage inquiries and other communication (GDPR Article 6 (1) (f)).
      </div>

      <div class="type">
        Use of ZP's website
      </div>
      <div class="answer">
        ZP may process personal data about visitors to the ZP's website. ZP use
        cookies and other information gathering methods to enhance the user
        experience and optimize the ZP website methods, where personal data as IP
        address may be collected. The legal basis for such processing is ZP's
        legitimate interest in maintaining the webpage and collect statistics
        (GDPR Article 6 (1) (f)). You can read more about our use of cookies in
        our Cookie Policy
      </div>

      <div class="type">
        Marketing, newsletters etc
      </div>
      <div class="answer">
        If you have signed up for marketing or our newsletter, we may process your
        name, contact information etc. in order to submit such materials to you.
        Such processing is based on your consent (GDPR Article 6 (1) (a)).
      </div>
      <div class="type">
        Recruitment
      </div>
      <div class="answer">
        If you apply to a position in ZP, ZP may process your personal data in
        order to assess your application such as CV, application, certificates,
        references and other information you may provide or which we need to
        verify to assess your application. The legal basis for such processing is
        normally that it is necessary in order to take steps at the request of the
        candidate prior to (potentially) entering into an employment contract. The
        processing may also be based on our legitimate interest in finding the
        best candidate for the position (GDPR Article 6 (1) (f)), or your consent
        (GDPR Article 6 (1) (a)).
      </div>
      <div class="type">
        Ensure compliance and legitimate interests
      </div>
      <div class="answer">
        ZP may also process personal data in order to comply with statutory
        obligations to which ZP is subject, and to safeguard own or third parties’
        legitimate interests, e.g. in relation to establishing a legal claim or
        preventing unauthorized access to or disclosure of personal data GDPR
        Article 6 (1) (f)).
      </div>
      <div class="type">
        Legal obligations
      </div>
      <div class="answer">
        ZP may process personal data due to legal obligations applicable to the
        operation of ZP (GDPR Article 6 (1) (c)), such as accounting obligations.
      </div>
      <br>
      <div class="subanswer">
        ZP may, on a case-by-case basis, process personal data for other purposes
        and rely on different legal grounds, such consent or legitimate interest
        or, in accordance with applicable data protection law, as set forth in an
        applicable privacy notice.
      </div>
      <br>
      <div class="question">
        RETENTION PERIOD
      </div>
      <div class="answer">
        ZP process among others personal data relating to contact persons at its
        customers, service providers and business partners, potential candidates
        and others who contact ZP or visits our webpage. The personal data may be
        provided by the data subject itself, from publicly accessible sources or
        third parties such as service providers, partners etc.
      </div>
      <div class="question">
        DISCLOSURE TO THIRD PARTIES
      </div>
      <div class="answer">
        We will only disclose your personal data to third parties to the extent we
        have a legal basis for such disclosure. We use data processors to collect,
        store and otherwise process personal data on our behalf. The relationship
        to such suppliers is governed by a data processor agreement, which inter
        alia ensures information security for your personal data. ZP will not
        process or store your personal data outside the EU/EEA. All processing in
        a third country will be subject to mechanisms ensuring sufficient security
        for your personal data, such as EU Standard Contractual Clauses or an
        adequacy decision from the EU Commission, in addition to all necessary
        requires steps under applicable law in order for such transfer of your
        personal data to be compliant with applicable law.
      </div>
      <div class="question">
        SECURITY
      </div>
      <div class="answer">
        ZP values your privacy rights and has taken reasonable steps to protect
        the users' privacy, including by implementation of physical, technical and
        organizational measures, to prevent loss, alterations, theft and
        unauthorized access to information stored and otherwise processed.
      </div>
      <div class="question">
        THIRD PARTY WEBSITES AND SOCIAL MEDIA
      </div>
      <div class="answer">
        ZP's websites may include links to other third-party sites. These
        third-party sites have own privacy policies that determines how personal
        data are collected and processed. If you submit personal information to
        any of these third-party sites, your information is governed by their
        privacy policies. ZP takes no responsibility for such third-party sites,
        how they are operated and how they process your personal data. We
        recommend that you familiarize yourself with such third-party sites'
        privacy policies and terms of use when visiting and using such sites.
      </div>
      <div class="subanswer">
        When you "like" or join our Facebook page or other social media accounts,
        this will be shared with the relevant platform. The same applies to any
        activities on our social media accounts, such as content posted by you or
        posts that you like. The relevant social media platform has own privacy
        policies, in which you can find more information about the processing of
        personal data in relation to such social media platforms.
      </div>
      <div class="question">
        YOUR RIGHTS
      </div>
      <div class="answer">
        As a data subject, you are entitled to request access to the personal data
        we process about you, request that ZP updates or corrects your personal
        data and/or withdraw any consent to processing. In some circumstances, you
        are also entitled to request that your personal data is erased, request
        restriction of processing or object to processing and/or request data
        portability. In order to utilise your rights, you may contact ZP by using
        the contact information stipulated in section 1 above.
      </div>
      <div class="subanswer">
        You are also entitled to lodge a complaint with a supervisory authority if
        you believe that ZP's processing of your personal data is contrary to
        relevant data protection laws.
      </div>
      <div class="question">
        CHANGES TO THE PRIVACY POLICY
      </div>
      <div class="answer">
        If ZP makes changes in the processing of personal data, this policy will
        be updated, and the change will be notified on the webpage or by use of
        your contact information.
      </div>
      <br>
      <div class="lastupdated">
        Last upated : 2021.02.08
      </div>
    </section>
  </section>
</template>

<script>
export default {
    methods:{
    contactSupport(){
     let url='https://www.zimmerpeacocktech.com/contact-support/'
      window.open(url,'_blank')
    }
  }
};
</script>

<style scoped>
span{
  color: var(--djuli-secondary-color);
  cursor: pointer;
}
.cookies_header {
  background: whitesmoke;
  padding: 1rem;
  color: var(--blue-marguerite);
    text-transform: uppercase;
}
.cookies_subsection{
    padding:2rem
}
.cookies_subsection_header{
      padding:0 2rem
}
.question {
  padding: 15px 0;
  font-weight: bold;
  color: var(--djuli-primary-color);
}
.type {
  padding: 8px 0;
  font-weight: 500;
  text-decoration: underline;
  text-align: justify;
}
.answer,
.subanswer {
  text-align: justify;
}
.subanswer {
  padding: 12px 0;
}
 section{
    padding:1rem 2rem
}


</style>